import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const VideoDialog = ({ open, onClose, videoUrl }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>
        Video Player
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {videoUrl && (
          <video
            width="100%"
            controls
            src={videoUrl}
            style={{ borderRadius: 8 }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default VideoDialog;
